import decode from 'jwt-decode';
import {BaseService} from './BaseService';
export default class NotificationService extends BaseService {
  getProfile() {
      // Using jwt-decode npm package to decode the token
      return decode(this.getToken());
  }

  getUnreadedNotifications() {
    const url = new URL(`${this.domain}/notifications/unreaded`);
      return this.fetch(url, {
          method: 'GET',
      }, true).then(res => {
          return Promise.resolve(res);
      });
  }

  getAllNotifications() {
    const url = new URL(`${this.domain}/notifications/all`);
      return this.fetch(url, {
          method: 'GET',
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  markNotificationAsRead(id) {
      return this.fetch(`${this.domain}/notifications/markread`, {
          method: 'POST',
          body: JSON.stringify({
            id,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/NotificationService.js